





































































import { AuthApiClient } from "@/api/auth_client";
import { AuthResponse } from "@/interfaces/auth";
import { Component, Vue } from "vue-property-decorator";
import CardComponent from "@/components/CardComponent.vue";

@Component({
  components: {
    CardComponent
  }
})
export default class Login extends Vue {
  private api = new AuthApiClient();

  private isLoading = false;
  private message = "";

  private form: any = {
    username: "",
    password: "",
    remember: true
  };

  mounted() {
    if (this.$store.state.userEmail) {
      this.form.username = this.$store.state.userEmail;
    }
  }

  submit() {
    this.isLoading = true;

    this.api
      .login(this.form.username, this.form.password)
      .then((response: AuthResponse) => {
        if (response.ok) {
          this.message = "";

          const auth = this.$store.state.auth;

          if (this.form.remember) {
            localStorage.auth = JSON.stringify(auth);
          }

          this.$router.push("/");
        }
      })
      .catch(error => {
        if (typeof error === "string") {
          this.message = this.$t(error);
        }
      })
      .finally(() => {
        this.isLoading = false;
      });
  }
}
